import React, { useEffect, useState, useCallback } from "react";

import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";

import { Flex, SimpleGrid, Button, useDisclosure } from "@chakra-ui/react";

import Group from "./Group";
import Information from "./Information";
import MultipleInformation from "./MultipleInformation";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { SuspenderModal } from "../Suspender";
import { DesativarModal } from "../Desativar";
import { ReativarModal } from "../Reativar";

import {
  Permission,
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { mascaraCNPJ, cep as cepMask } from "../../../utils/masks";

const VisualizarServicoAtendimento = ({ setLoadingPainel }) => {
  const {
    isOpen: isOpenSuspender,
    onOpen: onOpenSuspender,
    onClose: onCloseSuspender,
  } = useDisclosure();

  const {
    isOpen: isOpenDesativar,
    onOpen: onOpenDesativar,
    onClose: onCloseDesativar,
  } = useDisclosure();

  const {
    isOpen: isOpenReativar,
    onOpen: onOpenReativar,
    onClose: onCloseReativar,
  } = useDisclosure();

  const { id } = useParams();
  const history = useHistory();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { roleKeycloack, user } = useAuthProvider();

  const handleGetServicoAcolhimento = useCallback(async () => {
    await ServicoAcolhimentoService.getServicoAcolhimento(id)
      .then((res) => {
        const newData = {
          ...res?.data,
          mantenedora: res?.data?.mantenedoras,
        };

        setData(newData);
        document.title = `MCA - ${res.data.nomeFantasia}`;
        setIsLoading(false);
      })
      .catch((err) => {
        Swal.fire({
          title: "Atenção!",
          text: "Registro não encontrado",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        }).then(() => {
          history.push("/servico-acolhimento");
        });
      });
  }, [id, history, setData, setIsLoading]);

  useEffect(() => {
    handleGetServicoAcolhimento();
  }, [handleGetServicoAcolhimento]);

  const handleUpdate = () => {
    setLoadingPainel(true);
    handleGetServicoAcolhimento();
    history.push(`/servico-acolhimento/${id}`);
  };

  if (isLoading) {
    return (
      <Flex flexDir="column">
        <LoadingSpinner />
      </Flex>
    );
  }
  return (
    <div>
      <Flex flexDir="column">
        <Group title="Promotoria e Vara da Infância e Juventude">
          <Information
            title="Promotoria:"
            information={data?.promotoria?.nome}
          />
          <Information
            title="Vara da Infância:"
            information={data?.varaInfancia?.nome}
          />
          <Information
            title="Procedimento de inclusão:"
            information={data?.numeroInclusao}
          />
          {data?.dataDesativacao && (
            <Information
              title="Procedimento de desativação:"
              information={data?.procedimentoDesativacao}
            />
          )}
        </Group>
        <Group title="Caracterização do Serviço de Acolhimento">
          <Information
            title="Natureza:"
            information={
              data?.naturezaServico === "publica" ? "Pública" : "Privada"
            }
          />
          <Information
            title="Regime:"
            information={
              data?.tipoServicoAcolhimento?.regime === "SAI"
                ? "Serviço de Acolhimento Institucional"
                : "Serviço de Acolhimento Familiar"
            }
          />
          {data?.tipoServicoAcolhimento?.modalidade.toUpperCase() !==
            "NÃO SE APLICA" && (
            <Information
              title="Modalidade:"
              information={data?.tipoServicoAcolhimento?.modalidade}
            />
          )}
        </Group>
        <Group title="Identificação do Serviço de Acolhimento">
          <Information
            title="Nome Fantasia:"
            information={data?.nomeFantasia}
          />
          <Information title="Razão Social:" information={data?.razaoSocial} />
          <Information
            title="CNPJ:"
            information={data?.cnpj ? mascaraCNPJ(data?.cnpj) : ""}
          />
          <Information title="Site:" information={data?.site} />
          <Information
            title="Estado:"
            information={data?.endereco?.estado?.nome}
          />
          <Information
            title="Cidade:"
            information={data?.endereco?.municipio?.nome}
          />
          <Information
            title="Bairro:"
            information={
              data?.endereco?.bairro ? data?.endereco?.bairro?.nome : ""
            }
          />
          <Information
            title="Logradouro:"
            information={data?.endereco?.logradouro}
          />
          <Information
            title="Número:"
            information={
              data?.endereco?.numeroResidencia !== 0
                ? data?.endereco?.numeroResidencia
                : ""
            }
          />
          <Information
            title="CEP:"
            information={
              data?.endereco?.cep ? cepMask(data?.endereco?.cep) : ""
            }
          />
          <Information
            title="Complemento:"
            information={data?.endereco?.complemento}
          />
          <Information
            title="Ponto de referência:"
            information={data?.endereco?.pontoReferencia}
          />

          <MultipleInformation
            title="Órgão/Entidade Mantenedora:"
            informations={data?.mantenedoras?.map(
              (mantenedora) => mantenedora.nome
            )}
          />
        </Group>
        <Group title="Informações de Contato">
          <MultipleInformation
            title="Telefone (s):"
            informations={data?.telefones.map(
              (telefone) =>
                telefone.telefone +
                `${telefone.descricao ? ` (${telefone.descricao})` : ""}`
            )}
          />
          <MultipleInformation
            title="E-mail (s):"
            informations={data?.emails.map(
              (email) =>
                email.email +
                `${email.descricao ? ` (${email.descricao})` : ""}`
            )}
          />
        </Group>
        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          {roleKeycloack &&
            (roleKeycloack?.includes(servicoAcolhimentoFunc.editar) ||
              ((roleKeycloack?.includes(
                criancaFunc.visualizarTudoAcolhimento
              ) ||
                roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
                user?.orgaoExterno?.includes(data?.idPessoaJuridica))) && (
              <Button
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  history.push(`/servico-acolhimento/editar/${id}`);
                }}
              >
                Editar
              </Button>
            )}

          <Permission
            roleKeycloack={roleKeycloack}
            func={criancaFunc.visualizarTudo}
          >
            {(data?.desativado === "N" || !data?.desativado) && (
              <Button
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={onOpenDesativar}
              >
                Desativar
              </Button>
            )}
            {(data?.suspenso === "N" || !data?.suspenso) &&
              (data?.desativado === "N" || !data?.desativado) && (
                <Button
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={700}
                  fontSize="15px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={onOpenSuspender}
                >
                  Suspender
                </Button>
              )}
            {(data?.suspenso === "S" || data?.desativado === "S") && (
              <Button
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={onOpenReativar}
              >
                Reativar
              </Button>
            )}
          </Permission>
        </SimpleGrid>
        {
          <>
            <SuspenderModal
              isOpen={isOpenSuspender}
              onOpen={onOpenSuspender}
              onClose={onCloseSuspender}
              id={id}
              handleUpdate={handleUpdate}
            />
            <DesativarModal
              isOpen={isOpenDesativar}
              onOpen={onOpenDesativar}
              onClose={onCloseDesativar}
              id={id}
              handleUpdate={handleUpdate}
            />
            <ReativarModal
              isOpen={isOpenReativar}
              onOpen={onOpenReativar}
              onClose={onCloseReativar}
              id={id}
              isDesativado={data.desativado === "S"}
              handleUpdate={handleUpdate}
            />
          </>
        }
      </Flex>
    </div>
  );
};

export default VisualizarServicoAtendimento;
